<template>
  <div class="sidebar-card position-relative">
    <div class="content">
      <Skeleton :number="3" v-if="load_amount == true" />
      <div v-else>
        <h3 v-if="!account_details.balancedetails">Total des impayés</h3>
        <EmptyState
          :message="'Total indisponible'"
          v-if="!account_details.balancedetails"
        />
        <div v-else>
          <div class="text-muted fw-light">Total des impayés</div>
          <div class="amount mt-1">
            {{ account_details.balancedetails.billedbalance }} FCFA
          </div>
          <a @click="open_modal('credit-account')" class="credit-account"
            >Créditer mon compte</a
          >
          <i class="cash-icon mdi mdi-cash-multiple"></i>
          <CreditAccount id="credit-account" />
        </div>
      </div>
    </div>
    <div class="">
      <div v-if="load_amount == true" class="w-100"></div>
    </div>
  </div>
</template>

<script>
import Skeleton from "@/components/business/skeleton";
import EmptyState from "@/components/business/emptyState";
import CreditAccount from "@/components/business/utils/CreditAccount";
import { subscriber } from "@/services/";
import _ from "lodash";
export default {
  name: "mtn-business",
  components: {
    Skeleton,
    EmptyState,
    CreditAccount,
  },
  data() {
    return {
      load_amount: true,
      account_details: {},
    };
  },
  created: async function () {
    this.loadAccountBalance();
  },
  methods: {
    async loadAccountBalance() {
      if (this.$store.state.core.business_account.account_number !== null) {
        await subscriber.get_account_outstanding().then((response) => {
          this.load_amount = false;
          if (_.isUndefined(response.error)) {
            this.account_details = response;
            this.$store.state.core.business_account.account_details = response;
          } else {
            this.load_amount = false;
          }
        });
      } else {
        this.load_amount = false;
      }
    },
  },
  watch: {
    "$store.state.core.business_account.account_number"() {
      this.loadAccountBalance();
    },
  },
};
</script>
<style scoped>
.sidebar-card {
  overflow: hidden !important;
}
.sidebar-card .content {
  z-index: 9999 !important;
}
.cash-icon {
  position: absolute;
  right: -20px;
  bottom: 0%;
  font-size: 60px;
  z-index: 0;
  color: #ffe38a;
}
.sidebar-card .text-muted {
  font-size: 14px !important;
  font-weight: 400 !important;
}
.amount {
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
}
.credit-account {
  color: #004f71;
  font-size: 14px;
  font-weight: 500 !important;
  cursor: pointer !important;
}
.credit-account:hover,
.credit-account:active {
  text-decoration: underline !important;
  text-decoration-color: #004f71;
}
</style>